module.exports = __webpack_public_path__ + "static/media/temporary-domain-br.72a82a21.png";